import { Component, Input } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  @Input() email: string | undefined;
  checked = false;

  constructor(public languageService: LanguageService) {}

  get homeHref(): string {
    const p = this.languageService.getLanguagePrefix();
    return p ? `${p}/` : '/';
  }
}
